app.service('vue', function ($global, console, loading, log, simpleToastr) {
	var vueData = {};
	function getVue() {
		return vueData;
	}
	function setVue(data) {
		console.log('setVue', data);
		vueData = data;
		$('#vue-script').remove();
	}
	function vueDispacher(eventName, eventData = {}) {
		if (eventName == 'loading-start') {
			loading.start();
		} else if (eventName == 'loading-stop') {
			loading.stop();
		} else if (eventName == 'log-event') {
			log.event(eventData);
		} else if (eventName == 'simple-toastr-open') {
			simpleToastr.open(eventData);
		}
	}
	$global('getVue', getVue);
	$global('setVue', setVue);
	$global('vueDispacher', vueDispacher);
	return {};
});